$(document).ready(function(){
    $(document).on('click', '.menu-icon', function() {
         $('.mobile-menu-drawer').toggleClass('open-menu');
         $('body').toggleClass('opened-drawer');
         $('.overlay-content').toggleClass('open-overlay');
     });
 
     $(document).on('click', '.close-button', function() {
         $('.mobile-menu-drawer').removeClass('open-menu');
         $('body').removeClass('opened-drawer');
         $('.overlay-content').removeClass('open-overlay');
     });
 
     $(document).mouseup(function (e) {
         var container = $('.mobile-menu-drawer');
         if (!container.is(e.target) && container.has(e.target).length === 0 && $('.mobile-menu-drawer').hasClass('open-menu')) {
         $('.mobile-menu-drawer').removeClass('open-menu')
         $('.overlay-content').removeClass('open-overlay')
         $('body').removeClass('opened-drawer');
         }
     });

     $(document).on('click','.mobile-submenu-close',function(event) {
      event.preventDefault();
      $('.mobile-submenu').removeClass('show');
      $('.mobile-menu-drawer').removeClass('submenu-open');
     });
 
     $(document).on('click','.drawer-main .accordion-menu-list',function(event) {
         event.preventDefault();
         $('.plus-icon').removeClass('is-open');
         if($(this).next().hasClass('show')) {
         $(this).next().removeClass('show');
         $(this).find('.plus-icon').removeClass('is-open');
         } else {
         $(this).parent().parent().find('li .dropdown-grandchild').removeClass('show');
         $(this).next().toggleClass('show');
         $(this).find('.plus-icon').addClass('is-open');
         }
     });

  

  $(document).on('click','.mobile-submenu-close',function(event) {
      event.preventDefault();
      $('.dropdown-menus').removeClass('show');
     });

    $(document).on('click','.dropdown-grandchild-close',function(event) {
      event.preventDefault();
      $('.dropdown-grandchild').removeClass('show');
     });

       $(document).on('click','.drawer-main .has-megmenu',function(event) {
         event.preventDefault();
         $('.mobile-menu-drawer').addClass('submenu-open');
         $('.accordion-plus-icon').removeClass('is-open');
         if($(this).next().hasClass('show')) {
         $(this).next().removeClass('show');
         $(this).find('.accordion-plus-icon').removeClass('is-open');
         } else {
         $(this).parent().parent().find('li .dropdown-menus').removeClass('show');
         $(this).next().toggleClass('show');
         $(this).find('.accordion-plus-icon').addClass('is-open');
         }
     });  

       // Add en remove class on menu item hover  
      $('.big-nav > ul > li').mouseover(function(){
        $(this).addClass('show').siblings().removeClass('show');
      });
      
        $('.big-nav > ul > li > ul > li > ul > li').mouseover(function(){
        $(this).addClass('showes').siblings().removeClass('showes');
      });
      
      // Get the minimum height the big-nav elemtn
      var min_height = 50;
      $('.big-nav > ul > li > ul').each(function(){
        var this_height = $(this).outerHeight();
        if (this_height > min_height) min_height = this_height;
      });
      $('.big-nav > ul, .nav .big-nav > ul > li > ul').css('min-height', min_height + 'px');




                      // $(document).on('click','.mobile-submenu-close',function(event) {
                      //     event.preventDefault();
                      //     $('.dropdown-menus').removeClass('show');
                      //    });
                    
                      //   $(document).on('click','.dropdown-grandchild-close',function(event) {
                      //     event.preventDefault();
                      //     $('.dropdown-grandchild').removeClass('show');
                      //    });
                    
                      //      $(document).on('click','.drawer-main .has-megmenu',function(event) {
                      //        event.preventDefault();
                      //        $('.mobile-menu-drawer').addClass('submenu-open');
                      //        $('.accordion-plus-icon').removeClass('is-open');
                      //        if($(this).next().hasClass('show')) {
                      //        $(this).next().removeClass('show');
                      //        $(this).find('.accordion-plus-icon').removeClass('is-open');
                      //        } else {
                      //        $(this).parent().parent().find('li .dropdown-menus').removeClass('show');
                      //        $(this).next().toggleClass('show');
                      //        $(this).find('.accordion-plus-icon').addClass('is-open');
                      //        }
                      //    }); 


  
});



